export default __webpack_public_path__ + "static/media/meal_box.ee722c34.jpg";